import {
  TreeItem,
  TreeItemRenderContext,
  TreeInformation,
} from 'react-complex-tree'

import { cn } from '@tribeplatform/react-components/utils/cn'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function TreeItemArrow({
  item,
  context,
}: {
  item: TreeItem
  context: TreeItemRenderContext
  info: TreeInformation
}) {
  if (!item.isFolder) {
    return <div className="w-6 h-6 max-w-6 max-h-6 min-w-6 min-h-6"></div>
  }

  return (
    <div
      className={cn(
        'cursor-pointer p-1 rounded-full hover:bg-surface-hovered flex-shrink-0 transform transition-transform',
        !context.isExpanded && '-rotate-90 rtl:rotate-90',
      )}
      {...context.arrowProps}
    >
      <SvgIcon className="w-4 h-4" name="chevron-down" />
    </div>
  )
}
